// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__z3lrg","colCheckbox":"styles_colCheckbox__2AFBe"};